import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

export const useGQLContext = () => {
  const [token] = useContext(AuthContext);
  return { headers: { 'admin-authorization': token } };
};
